var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcalLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 30",
    style: {
      enableBackground: "new 0 0 150 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F18C21;}\n\t.st1{fill:#EE7624;}\n\t.st2{fill:#089BD7;}\n\t.st3{fill:#00BBD3;}\n\t.st4{fill:#F6BD17;}\n\t.st5{fill:#75BD43;}\n\t.st6{fill:#00A7E0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,5h-9.3c-0.7,0-1.4,0.6-1.4,1.3c0,0.7,0.6,1.3,1.4,1.3h9.3c0.7,0,1.3-0.6,1.3-1.3C22.3,5.6,21.7,5,20.9,5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,0.8H14.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h23.7c0.7,0,1.3-0.6,1.3-1.3 C39.6,1.5,39,0.8,38.2,0.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.2,25.9H14.5c-0.7,0-1.4,0.6-1.4,1.3c0,0.7,0.6,1.3,1.4,1.3h18.7c0.7,0,1.3-0.6,1.3-1.3 C34.6,26.5,34,25.9,33.2,25.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.6,17.5h-9.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h9.5c0.7,0,1.3-0.6,1.3-1.3 C22,18.1,21.4,17.5,20.6,17.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.1,9.2H5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h18c0.7,0,1.3-0.6,1.3-1.3 C24.4,9.8,23.8,9.2,23.1,9.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.4,13.4H14.5c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h14.9c0.7,0,1.3-0.6,1.3-1.3 C30.8,14,30.1,13.4,29.4,13.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.4,21.7H2.3C1.6,21.7,1,22.3,1,23c0,0.7,0.6,1.3,1.3,1.3h15.1c0.7,0,1.3-0.6,1.3-1.3 C18.8,22.3,18.2,21.7,17.4,21.7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M50.3,28.6c-0.8,0-1.5-0.7-1.5-1.5V2.4c0-0.8,0.7-1.5,1.5-1.5h17.2c0.8,0,1.3,0.6,1.3,1.3 c0,0.7-0.6,1.3-1.3,1.3H51.8v9.8h13.9c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3H51.8v9.8h15.9c0.8,0,1.3,0.6,1.3,1.3 c0,0.8-0.6,1.3-1.3,1.3H50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.4,28.9c-7.9,0-13.8-6.1-13.8-14.1v-0.1c0-8,6.1-14.2,13.9-14.2c4.9,0,7.7,1.8,9.8,3.6 C94.6,4.3,95,4.7,95,5.3c0,0.8-0.7,1.5-1.5,1.5c-0.4,0-0.8-0.2-1-0.3c-2.5-2.2-4.9-3.2-8-3.2c-6.1,0-10.8,4.9-10.8,11.4v0.1 c0,6.4,4.7,11.5,10.8,11.5c3.2,0,5.7-1,8.3-3.4c0.3-0.3,0.6-0.4,0.9-0.4c0.7,0,1.4,0.7,1.4,1.4c0,0.4-0.2,0.8-0.5,1 C91.5,27.7,88.5,28.9,84.4,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.1,28.8c-0.6,0-1.2-0.4-1.5-1.1l-3-6.5h-15.3l-2.9,6.6c-0.3,0.7-0.8,1-1.4,1c-0.8,0-1.3-0.6-1.3-1.3 c0-0.3,0.1-0.5,0.2-0.8L109.1,2c0.4-0.9,1-1.3,1.9-1.3h0.2c0.9,0,1.5,0.4,1.9,1.3l11.3,24.6c0.1,0.3,0.2,0.5,0.2,0.8 C124.5,28.1,123.9,28.8,123.1,28.8z M104.5,18.5h13L111,4L104.5,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M129.4,28.6c-0.8,0-1.5-0.7-1.5-1.5V2.3c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v23.6h14.4 c0.7,0,1.3,0.6,1.3,1.4c0,0.7-0.6,1.3-1.3,1.3H129.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcalLogo);
export default __webpack_public_path__ + "static/media/ECAL_Logo.73a3a421b2791f65391fc709c9db93e3.svg";
export { ForwardRef as ReactComponent };